import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex w-full p-4" };
const _hoisted_2 = { class: "capitalize text-primary text-3xl font-bold w-full" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("span", { class: "block w-16 h-1 bg-primary mb-1" }, null, -1);
const _hoisted_4 = { class: "bg-white w-full pb-4" };
const _hoisted_5 = { class: "flex flex-row-reverse w-full" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["inline-block bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all max-w-xl align-middle", { width: `w-${_ctx.width}`, height: `h-${_ctx.height}` }])
    }, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("h1", _hoisted_2, [
                _renderSlot(_ctx.$slots, "header"),
                _hoisted_3
            ])
        ]),
        _createElementVNode("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "default")
        ]),
        _createElementVNode("div", _hoisted_5, [
            _renderSlot(_ctx.$slots, "actions")
        ])
    ], 2));
}
